import {
	initialStateObjectCollection,
	updateItemInStateItems,
} from "funkis-foundation/redux/utils/reducerUtils";

import { UPDATE_TIMER } from "../constants/ActionConstants";

const timers = (state = initialStateObjectCollection(), action) => {
	switch (action.type) {
		case UPDATE_TIMER:
			return updateItemInStateItems(state, action.item) as any;
		default:
			return state;
	}
};

export default timers;
